import Router from 'next/router';

import config from 'config';

const contextRoot = config.get('client.contextRoot');

/**
 * Составляет URL из contextRoot и переданной строки.
 * Пример, contextRoot - /alfaform-refpil и path - /counter
 * Итог - /alfaform-refpil/counter */
export const composeUrl = (path: string): string => `${contextRoot}${path}`;

/** На данный момент Next.js не поддерживает изменение basePath,
 * а соответственно и то, что большинство наших приложений сидит не на rootPath.
 * По дефолту все его редиректы будут удалять из строки браузера contextRoot.
 * Эти функции нужны для корректного роутинга с использованием contextRoot */
export const router = {
    /** Переход на внутреннюю страницу с перезагрузкой страницы */
    internalRedirect: (url: string) => window.location.assign(composeUrl(url)),
    /** Переход на внешнюю страницу */
    externalRedirect: (url: string) => window.location.assign(url),
    /** Внутренний переход на другую страницу без перезагрузки (SPA). Маскирует в браузере редирект с /step1 на /contextRoot/step1 */
    push: (url: string) => Router.push(url, composeUrl(url))
};
